if (window.BaseModal && !customElements.get('ingredients-modal')) {
  customElements.define('ingredients-modal', class IngredientsModal extends window.BaseModal {})
}

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('ingredients-modal')
  if (!modal) return

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ingredients-modal-open]')
    if (!opener) return
    event.preventDefault()
    modal.open(opener)
  })
})
